export default __webpack_public_path__ + "6e6a4a81a7f71c0ba13406386fa59b63.woff2";